import {
  ADD_LANGUAGES,
  ADD_NEW_QUESTION,
  ADD_QUESTION,
  ADD_QUESTION_INTO_PARENT,
  ADD_SCREEN,
  CHANGE_SETTING_CURRENT_LANGUAGE,
  CHANGE_TAB,
  CHECK_QUESTION,
  CLONE_QUESTION,
  DELETE_QUESTION,
  DELETE_SCREEN,
  MOVE_QUESTION_FROM_GROUP_TO_GROUP,
  REMOVE_LANGUAGE,
  REORDER_QUESTIONS,
  SET_CURRENT_SCREEN,
  SET_DEFAULT_LANGUAGE,
  SORT_IN_GROUP_QUESTIONS,
  SORT_QUESTIONS,
  TAKE_OUT_GROUP_QUESTIONS,
  TOGGLE_DRAWER,
  UPDATE_CHOICES_LIST,
  UPDATE_FORM_SETTINGS,
  UPDATE_QUESTION_SETTING,
  ADD_NEW_QUESTION_INTO_GROUP,
  ADD_NEW_GROUP_QUESTION,
  UPDATE_CHOICES_LIST_INIT,
  SET_PREVIEW,
  UPDATE_THEME_SETTING,
  UPDATE_FORM_CONFIGS,
  UPDATE_CONFIG_TEMP
} from "./constants";

export function setPreview(value) {
  return {
    type: SET_PREVIEW,
    value: value,
  };
}

export function addNewQuestion(
  page_name,
  question_id,
  question_type,
  question_collector,
  destination_index,
  newQuestion = ''
) {
  return {
    type: ADD_NEW_QUESTION,
    page_name: page_name,
    question_id: question_id,
    question_type: question_type,
    question_collector: question_collector,
    destination_index: destination_index,
    new_question: newQuestion
  };
}

export function addNewGroupQuestion(
  page_name,
  question_id,
  question_type,
  question_collector,
  destination_index,
  list_child
) {
  return {
    type: ADD_NEW_GROUP_QUESTION,
    page_name: page_name,
    question_id: question_id,
    question_type: question_type,
    question_collector: question_collector,
    destination_index: destination_index,
    list_child: list_child
  };
}


export function sortQuestions(source_index, destination_index) {
  return {
    type: SORT_QUESTIONS,
    source_index,
    destination_index,
  };
}

export function addQuestion(
  page_name,
  question_id,
  question_type,
  question_collector,
  destination_index
) {
  return {
    type: ADD_QUESTION,
    page_name: page_name,
    question_id: question_id,
    question_type: question_type,
    question_collector: question_collector,
    destination_index: destination_index,
  };
}

export function deleteQuestion(page_name, question_id) {
  return {
    type: DELETE_QUESTION,
    page_name: page_name,
    question_id: question_id,
  };
}

export function cloneQuestion(questionId, quantity) {
  return {
    type: CLONE_QUESTION,
    questionId,
    quantity,
  };
}

export function reorderQuestions(page_name, from_index, to_index) {
  return {
    type: REORDER_QUESTIONS,
    page_name: page_name,
    from_index: from_index,
    to_index: to_index,
  };
}

export function checkQuestion(question_id) {
  return {
    type: CHECK_QUESTION,
    question_id: question_id,
  };
}

export function updateQuestionSetting(
  question_id,
  question_setting_key,
  question_setting_value,
  question_appearance_value ={}
) {
  return {
    type: UPDATE_QUESTION_SETTING,
    question_id: question_id,
    question_setting_key: question_setting_key,
    question_setting_value: question_setting_value,
    question_appearance_value: question_appearance_value
  };
}

export function updateConfigTemp(
  question_id,
  config
) {
  return {
    type: UPDATE_CONFIG_TEMP,
    question_id: question_id,
    config: config,
  };
}

export function updateThemeConfig(key_theme,value_theme) {
  return {
    type: UPDATE_THEME_SETTING,
    key_theme: key_theme,
    value_theme: value_theme
  };
}

export function updateChoicesList(changes) {
  return {
    type: UPDATE_CHOICES_LIST,
    dataChanges: changes,
  };
}

export function updateChoicesListInit(questionId,data, choiceName ='') {
  return {
    type: UPDATE_CHOICES_LIST_INIT,
    data: data,
    choiceName: choiceName,
    question_id: questionId
  };
}

export function updateFormSettings(setting_key, setting_value) {
  return {
    type: UPDATE_FORM_SETTINGS,
    setting_key: setting_key,
    setting_value: setting_value,
  };
}

export function addLanguages(languages) {
  return {
    type: ADD_LANGUAGES,
    languages: languages
  };
}

export function removeLanguages(language) {
  return {
    type: REMOVE_LANGUAGE,
    language: language,
  };
}

export function setDefaultLanguage(language) {
  return {
    type: SET_DEFAULT_LANGUAGE,
    language: language,
  };
}

export function changeSettingCurrentLanguage(
  question_id,
  setting_key,
  language
) {
  return {
    type: CHANGE_SETTING_CURRENT_LANGUAGE,
    question_id: question_id,
    setting_key: setting_key,
    language: language,
  };
}

export function changeTab(tab) {
  return {
    type: CHANGE_TAB,
    tab: tab,
  };
}

//screen should use to specify repeat or screen
export function addScreen(screen) {
  return {
    type: ADD_SCREEN,
    screen: screen,
  };
}

export function setCurrentScreen(screen) {
  return {
    type: SET_CURRENT_SCREEN,
    screen: screen,
  };
}

export function toggleDrawer(anchor, open) {
  return {
    type: TOGGLE_DRAWER,
    anchor,
    open,
  };
}

export function deleteScreen(screen) {
  return {
    type: DELETE_SCREEN,
    screen: screen + "",
  };
}

export function addQuestionIntoParent(
  parent,
  question_id,
  destination_index,
  newQuestion
) {
  return {
    type: ADD_QUESTION_INTO_PARENT,
    parent,
    question_id,
    destination_index,
    newQuestion
  };
}

export function takeOutGroupQuestion(
  parent,
  question_id,
  source_index,
  destination_index
) {
  return {
    type: TAKE_OUT_GROUP_QUESTIONS,
    parent,
    question_id,
    source_index,
    destination_index,
  };
}

export function sortInGroupQuestion(
  parent,
  question_id,
  source_index,
  destination_index
) {
  return {
    type: SORT_IN_GROUP_QUESTIONS,
    parent,
    question_id,
    source_index,
    destination_index,
  };
}

export function moveQuestionFromGroupToGroup(
  question_id,
  from_group,
  to_group,
  source_index,
  destination_index
) {
  return {
    type: MOVE_QUESTION_FROM_GROUP_TO_GROUP,
    question_id,
    from_group,
    to_group,
    source_index,
    destination_index,
  };
}

export function addNewQuestionIntoGroup(
  container, question_id, destination_index, page_name, question_type, question_collector,newQuestion=''
) {
  return {
    type: ADD_NEW_QUESTION_INTO_GROUP,
    page_name: page_name,
    question_id: question_id,
    question_type: question_type,
    question_collector: question_collector,
    destination_index: destination_index,
    parent: container,
    new_question: newQuestion
  };
}

export function updateFormConfigs(setting_key, setting_value) {
  return {
    type: UPDATE_FORM_CONFIGS,
    setting_key: setting_key,
    setting_value: setting_value,
  };
}